import { useAuthState } from './AuthProvider'

/** Convenience hook — true while the runtime considers the session live. */
export const useIsAuthenticated = (): boolean => {
    const state = useAuthState()
    return state.tag === 'authenticated' || state.tag === 'refreshing'
}
